import { Button, Card, Flex, Form, Segmented, Select, Space, Typography } from 'antd';
import { useForm } from '@refinedev/antd';
import { IExperienceEvent } from '../../../interfaces/experience';

const fields = ['id', 'name', 'status', 'publishStatus'];

export const StatusForm = () => {
  const { formProps, form, queryResult, mutationResult } = useForm<IExperienceEvent>({
    resource: 'experienceEvents',
    action: 'edit',
    redirect: false,
    autoSave: {
      enabled: true,
    },
    meta: {
      fields,
    },
    mutationMeta: {
      fields: [{ experienceEvent: fields }],
    },
  });

  const isLoading = queryResult?.isLoading || mutationResult?.isLoading;

  return (
    <Card>
      <Flex justify="space-between">
        <Typography.Title>{queryResult?.data?.data.name}</Typography.Title>
        <Form data-test-id="StatusForm" layout="horizontal" {...formProps}>
          <Space>
            <Form.Item name="status">
              <Segmented
                color={'blue'}
                options={[
                  { label: '準備中', value: 'preparing' },
                  { label: '予約受付中', value: 'reservation' },
                  { label: '開催中', value: 'in_progress' },
                  { label: '終了', value: 'finished' },
                ]}
              />
            </Form.Item>
            <Form.Item name="publishStatus">
              <Segmented
                options={[
                  { label: '下書き', value: 'draft' },
                  { label: '限定公開', value: 'limited' },
                  { label: '公開', value: 'published' },
                ]}
              />
            </Form.Item>
          </Space>
        </Form>
      </Flex>
    </Card>
  );
};
